import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 15697 17363"
    {...props}
  >
    <path
      d="M9176 15050c-73-62-159-138-159-138s0-272 13-349l194-4628 1641 438 243-887 373 105-243 880 657 178 227-815 369 101-224 811 661 178 202-742 374 102-203 737 2034 544c166 45 284-57 264-227l-167-1415c-16-170-157-364-316-434L9245 6824l-81-4612c-17-851-328-1735-701-1970-138-89-313-137-491-146h-4c-178 9-353 49-494 138-373 227-710 1098-742 1949l-182 4611L621 9327c-158 69-304 260-328 430L98 11171c-20 166 94 272 260 232l1929-471-179-648 373-102 183 657 660-158-202-746 372-101 207 753 661-161-231-835 373-105 235 850 1762-429 93 4632c13 73 9 344 9 344s-89 77-162 134l-969 734-206 1458 65-12 4967 69-170-1468-952-748z"
      style={{
        fill: "#262626",
        stroke: "#fefefe",
        strokeWidth: 192.4,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
